import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import { useMagicLink } from 'Views/Authentication/useMagicLink';
import { AuthenticationLayoutLoading } from 'Views/Authentication/Components/AuthenticationLayoutLoading';
import { getLayout } from './Layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AuthenticationContent = ({
  collection,
  authResource,
  setCollection,
  refreshCollection,
}) => {
  const Layout = getLayout(authResource);

  const { loading } = useMagicLink(setCollection);

  return (
    <>
      {loading
        ? (
          <AuthenticationLayoutLoading />
        )
        : (
          <MetaResourceRenderer
            key={authResource.instanceId()}
            resource={authResource}
            layout={Layout}
            onSubmit={setCollection}
            metaOverrideSet={metaOverrideSet}
            LayoutProps={{
              collection,
              onlyUnsourcedErrors: true,
              setCollection,
              setAuthCollection: setCollection,
              refreshAuthCollection: refreshCollection,
            }}
          />
        )
      }
    </>
  );
};

AuthenticationContent.propTypes = {
  collection: PropTypes.object.isRequired,
  authResource: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
  refreshCollection: PropTypes.func.isRequired,
};
